// Shared data-shaping for the HR-documents pages (Completed / Incomplete / Canceled).
//
// Their endpoints return { documents, employees } where employees are sent once in
// an id-keyed map (rather than nested and duplicated on every document). This stitches
// each document back to its employee so the rest of each page can keep reading
// `d.employee.*`, and freezes the whole graph: the rows are read-only display data,
// and freezing keeps Vue from deep-proxying thousands of documents + their
// employee/company objects, which is the dominant per-interaction cost at scale.

export function rejoinAndFreezeDocuments(resp) {
    const employees = resp.employees
    Object.values(employees).forEach(e => {
        if (e.company) { Object.freeze(e.company) }
        Object.freeze(e)
    })

    const documents = resp.documents
    documents.forEach(d => {
        d.employee = employees[d.employee_id]
        d.company_security_profile_ids = d.employee.company_security_profile_ids
        Object.freeze(d)
    })

    return Object.freeze(documents)
}
